// src/components/MessageFilter.js
import React from "react";

const MessageFilter = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  onClear,
  totalMessages, // Total count of sent messages
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-md p-4 sm:p-6 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Left side: Date filters */}
        <div className="flex flex-wrap items-end gap-3">
          {/* From Date */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-600 mb-1">From</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* To Date */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-600 mb-1">To</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Clear Button */}
          {(fromDate || toDate) && (
            <button
              onClick={onClear}
              className="text-blue-600 text-sm font-medium hover:underline pb-2"
            >
              Clear Filters
            </button>
          )}
        </div>

        {/* Right side: Total Sent Messages */}
        <div className="flex items-center">
          <p className="text-base sm:text-lg font-semibold text-gray-800 whitespace-nowrap">
            Total Sent Messages:{" "}
            <span className="text-blue-600">{totalMessages}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MessageFilter;
